import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class WaiterRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.SETTINGS,
      resolver: AlwaysShowRouteResolver,
      title: 'Receipts',
      icon: 'icon-reports.svg',
      position: 1
    };
  }
}
